import React, { FC, useContext } from "react";
import { useHistory } from "react-router-dom";

import {
  IOnClickStudentAvatarParams,
  RealizationStamp,
  IBoxDashboard,
} from "../../../state";
import { Context, sharedRealizationPath } from "../../../store/teacher";
import RealizationItem from "../../../molecules/teacher/RealizationItem";

import SubmitterList, { SubmitterFilter } from "./SubmitterList";
import styles from "./Realizations.module.scss";

type SubmitterProps = {
  filter: SubmitterFilter;
  onChangeFilter: (filter: SubmitterFilter) => void;
  today: string;
  markedDates: string[];
  onChangeViewMonth: (year: number, month: number) => void;
};

type Props = {
  box: IBoxDashboard | null;
  pageType: "teacher" | "box";
  calling: boolean;
  loadMoreRef: React.RefObject<HTMLDivElement>;
  submitter?: SubmitterProps;
  showStudentDetail: (params: IOnClickStudentAvatarParams) => void;
  createFeedback: (realization_id: number, content: string) => void;
  createStampReaction: (realizationId: number, stamp: RealizationStamp) => void;
  deleteFeedback: (feedbackId: number, realizationId?: number) => void;
  updateFeedback: (
    feedbackId: number,
    content: string,
    realizationId?: number,
  ) => void;
  addFavorite: (id: number) => void;
  removeFavorite: (id: number) => void;
};

const Realizations: FC<Props> = ({
  box,
  pageType,
  calling,
  loadMoreRef,
  submitter,
  showStudentDetail,
  createFeedback,
  createStampReaction,
  deleteFeedback,
  updateFeedback,
  addFavorite,
  removeFavorite,
}) => {
  const { contextState } = useContext(Context);
  const history = useHistory();

  // IntersectionObserverが複数回発火するケースがあり、同じidのrealizationが重複して追加されてしまうため重複を排除
  const uniqueRealizations = Array.from(
    new Map(contextState.realizations.map(r => [r.id, r])).values(),
  );

  return box ? (
    <div className={styles.wrapper}>
      {pageType === "box" && submitter && (
        <div className={styles.sidebar}>
          <SubmitterList calling={calling} {...submitter} />
        </div>
      )}
      <div className={styles.container}>
        {box.template && (
          <div className={styles.boxTemplate}>{box.template.content}</div>
        )}
        {!uniqueRealizations.length && calling ? (
          <div className={styles.loading}>読み込み中</div>
        ) : uniqueRealizations.length ? (
          <div className={styles.list}>
            {uniqueRealizations.map(r => (
              <RealizationItem
                key={r.id}
                realization={r}
                feedbacks={contextState.feedbacks.filter(
                  f => f.realization_id === r.id,
                )}
                currentTeacherId={contextState.teacher.id}
                onClick={() => history.push(`${sharedRealizationPath}${r.id}`)}
                onAvatarClick={showStudentDetail}
                onFeedbackSubmit={createFeedback}
                onStampSubmit={createStampReaction}
                onDeleteFeedback={
                  deleteFeedback
                    ? feedbackId => deleteFeedback(feedbackId, r.id)
                    : undefined
                }
                onUpdateFeedback={
                  updateFeedback
                    ? (feedbackId, content) =>
                        updateFeedback(feedbackId, content, r.id)
                    : undefined
                }
                addFavorite={addFavorite}
                removeFavorite={removeFavorite}
              />
            ))}
            <div className={styles.loadMore} ref={loadMoreRef}>
              {calling ? "読み込み中" : ""}
            </div>
          </div>
        ) : (
          !calling && (
            <div className={styles.emptyData}>まだストックがありません。</div>
          )
        )}
      </div>
    </div>
  ) : null;
};

export default Realizations;
